import DBModal from 'components/modal/modal';
import {DatePicker, Form, Select} from 'antd';
import {useMutation} from '@apollo/client';
import {fieldRules} from 'utils/helper';
import {UploadCSV} from 'components/uploadCSV';
import {BULK_ORDER_OPERATIONS} from 'graphql/mutations/stocks';
import {toast} from 'react-toastify';
import SubmitButton from 'components/Startup/components/SubmitButton';
import moment from 'moment';
import {FieldGroup, ModalShell} from './ui/ModalShell';

export const BookToOrderBookModal = ({
  form,
  orderModal,
  setOrderModal,
  onKeyCopied,
}) => {
  const type = Form.useWatch('type', form);

  const [bulkOrderOperation, {loading}] = useMutation(BULK_ORDER_OPERATIONS, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const handleSubmit = values => {
    bulkOrderOperation({
      variables: {
        input: {
          brokerbook: {
            ...values,
            placedAt: moment(values.placedAt).format(),
          },
        },
      },
    })
      .then(({data: {bulkOrderOperation}}) => {
        if (bulkOrderOperation.__typename === 'Error') {
          toast.error(bulkOrderOperation.message);
        } else {
          if (bulkOrderOperation?.data?.key) {
            const copiedKey = bulkOrderOperation?.data?.key;
            navigator.clipboard.writeText(copiedKey);
            onKeyCopied?.(copiedKey, 'Broker Book to Order Book');
            toast.warn('Order Book Key Copied to Clipboard Successfully');
          }
          toast.success(bulkOrderOperation.message);
          setOrderModal({open: false, type: null});
          form.resetFields();
        }
      })
      .catch(error => toast.error(error.message));
  };

  return (
    <DBModal
      isOpen={orderModal.open}
      width={600}
      handleClose={() => setOrderModal({open: false, type: null})}
      content={
        <Form onFinish={handleSubmit} form={form} layout="vertical">
          <ModalShell
            title="Broker book to order book"
            subtitle="Loads a broker's book into the order book from a CSV. A market book also needs the unbundled file."
            footer={
              <SubmitButton disabled={loading} label="Load into order book" />
            }>
            <FieldGroup title="Book">
              <Form.Item name="type" label="Type" rules={[fieldRules('type')]}>
                <Select>
                  <Select.Option value="LIMIT">Limit</Select.Option>
                  <Select.Option value="MARKET">Market</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="placedAt" label="Placed At">
                <DatePicker allowClear showTime style={{width: '100%'}} />
              </Form.Item>
            </FieldGroup>
            <FieldGroup title="Files" columns={1}>
              <Form.Item
                name="bundle"
                label="Bundle"
                rules={[fieldRules('bundle')]}
                trigger="onChange"
                getValueFromEvent={v => v}
                valuePropName="value">
                <UploadCSV
                  clear={() => form.setFieldsValue({bundle: undefined})}
                  sampleLink="https://dabacdn-bucket001.s3.us-east-1.amazonaws.com/contents/bundled.csv"
                />
              </Form.Item>
              {type === 'MARKET' && (
                <Form.Item
                  name="unbundled"
                  label="Unbundled"
                  rules={[fieldRules('Unbundled')]}
                  trigger="onChange"
                  getValueFromEvent={v => v}
                  valuePropName="value">
                  <UploadCSV
                    clear={() => form.setFieldsValue({unbundled: undefined})}
                    sampleLink="https://dabacdn-bucket001.s3.us-east-1.amazonaws.com/contents/unbundled.csv"
                  />
                </Form.Item>
              )}
            </FieldGroup>
          </ModalShell>
        </Form>
      }
    />
  );
};
